// extracted by mini-css-extract-plugin
export default {"timeAndDate":"TimeAndDate_timeAndDate__F2crb","time":"TimeAndDate_time__1Mt-p","date":"TimeAndDate_date__Y5KEX"};